import { readable, writable } from 'svelte/store';

export const pageOffset = writable(0);
export const universalScroll = writable(true);
export const parallaxStore = writable([]);
export const topNavigationOpened = writable(false);
export const logoDone = writable(false);
export const isPortraitScreen = writable(false);
export const toggleUniversalToPageScroll = writable(500);
export const shareSectionHidden = writable(true);
export const firstBottomBoxVisible = writable(false);

export const apiAuthorization = readable('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmNTFlZDE3MDBlMGU2ZjMwMDY0M2RkYiIsImF1dGgiOnRydWV9.PHNYUwqaqtr1VK3hzltqTs-yc70IFBtHMqik3fprjRM');
